module.exports = __webpack_public_path__ + "static/media/img_Characterdesign-Junior-05Merit_Prize_J13.7f697709.png";